export default "__VITE_ASSET__CSUeJD0X__"